import React from 'react';
import composeClassNames from '../../../../utils/composeClassNames';
import CrossIcon from '../../Icons/CrossIcon';

import './Chip.css';

const colorClassNames = {
    primary: 'Chip--primary',
};

const variantClassNames = {
    outlined: 'Chip--outlined',
};

function Chip({
    children,
    color,
    variant,
    onClick,
    onDelete,
    deleteLabel = 'Delete',
    className,
}) {
    const classNames = composeClassNames([
        'Chip',
        colorClassNames[color],
        variantClassNames[variant],
        className,
    ]);

    const label = onClick ? (
        <button type="button" className="Chip__label" onClick={onClick}>
            {children}
        </button>
    ) : (
        <span className="Chip__label">{children}</span>
    );

    return (
        <div className={classNames}>
            {label}
            {onDelete ? (
                <button
                    type="button"
                    className="Chip__delete"
                    aria-label={deleteLabel}
                    onClick={onDelete}
                >
                    <CrossIcon />
                </button>
            ) : null}
        </div>
    );
}

export default Chip;
